import SelectAsync from "../../../../../../packages/design-system/select/examples/constellation/select-async";
import RAW_UNSAFEUPUPSLASHUPUPSLASHexamplesSLASHconstellationSLASHselect_async from "!!raw-loader!../../../../../../packages/design-system/select/examples/constellation/select-async";
import * as React from 'react';
export default {
  SelectAsync,
  RAW_UNSAFEUPUPSLASHUPUPSLASHexamplesSLASHconstellationSLASHselect_async,
  React
};